import { inject, Injectable } from '@angular/core';
import { MatSortHeaderIntl } from '@angular/material/sort';
import { TranslocoService } from '@jsverse/transloco';

@Injectable({ providedIn: 'root' })
export class LocalizedSortIntl extends MatSortHeaderIntl {
  private transloco = inject(TranslocoService);

  constructor() {
    super();
    this.transloco.langChanges$.subscribe(() => {
      this.changes.next();
    });
  }

  sortButtonLabel = (id: string): string => {
    return this.transloco.translate('material.sort.sortBy', { id });
  };
}
